import { memo } from "react";
import IntroPage from "@/components/IntroPage";
import { BookingButton } from "@/components/BookingButton";
import { pressQuote, rating } from "@/data/social-proof";
import type { CategoryRow, SectionRow } from "@/lib/categories.functions";
import SectionRenderer from "./sections/SectionRenderer";
import { FeaturedInMarquee, IntroStatement, ReviewsSection } from "./IntroExtras";

type Props = {
  category: CategoryRow;
  sections: SectionRow[];
  appendCta?: boolean;
  experienceSlug?: string | null;
};

function IntroCategoryPageImpl({ sections, appendCta, experienceSlug }: Props) {
  return (
    <div className="relative w-full">
      <section className="relative w-full overflow-hidden aspect-[4/5] sm:aspect-[16/10] max-h-[78svh]">
        <IntroPage experienceSlug={experienceSlug} />
        <div className="absolute bottom-0 left-0 right-0 z-10">
          <FeaturedInMarquee experienceSlug={experienceSlug} overlay />
        </div>
      </section>
      <IntroStatement experienceSlug={experienceSlug} />
      <ReviewsSection experienceSlug={experienceSlug} />
      {sections.map((s) => (
        <SectionRenderer key={s.id} section={s} />
      ))}
      {appendCta && <CtaSection />}
    </div>
  );
}



const IntroCategoryPage = memo(IntroCategoryPageImpl);
export default IntroCategoryPage;

function CtaSection() {
  return (
    <section
      className="relative w-full overflow-hidden bg-background"
      style={{ minHeight: "92svh" }}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center px-8 text-center">
        <div className="text-[10px] tracking-[0.45em] uppercase text-gold/90 mb-6">
          Time together feels different here
        </div>
        <div className="flex items-center gap-3 mb-2">
          <span className="font-serif text-2xl text-foreground">{rating.score.toFixed(1)}</span>
          <span className="text-foreground/55 text-sm">/ 5</span>
        </div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-foreground/55 mb-10">
          From {rating.count}+ {rating.source.toLowerCase()}
        </div>
        <blockquote className="font-serif italic text-xl md:text-2xl leading-snug text-foreground/95 max-w-[24ch] text-shadow-soft">
          &ldquo;{pressQuote.quote}&rdquo;
        </blockquote>
        <div className="mt-4 text-[10px] tracking-[0.3em] uppercase text-gold/85">
          — {pressQuote.outlet}
        </div>
        <BookingButton className="mt-12 font-serif italic text-base text-background bg-gold/95 px-8 py-3.5 rounded-full tracking-wide shadow-[0_8px_40px_-12px_rgba(0,0,0,0.8)] hover:bg-gold transition">
          Book your stay
        </BookingButton>
      </div>
    </section>
  );
}
